/**
 * `/$org/apps/probe/briefing`: what the examiner has read before the call.
 *
 * @module routes/$org.apps.probe.briefing
 */
import { createFileRoute } from "@tanstack/react-router";

import { ProbeBriefingPage } from "../components/apps/probe/ProbeBriefingPage";

export const Route = createFileRoute("/$org/apps/probe/briefing")({
  component: ProbeBriefingPage,
});
